import React, { FC } from 'react';
import {
  Typography,
  Box,
  CircularProgress,
  CircularProgressProps,
  circularProgressClasses,
} from '@mui/material';
import { IconCheck } from '../../../../utils/icons';

interface Props extends CircularProgressProps {
  value: number;
}

export const CircularPercentage: FC<Props> = (props) => {
  const { value, size = 40 } = props;

  if (value === 100) {
    // stroke is an SVG attribute (no var()) and this success green has no token
    return <IconCheck stroke="#0a0" width={Number(size)} height={Number(size)} />
  }
  return (
    <Box sx={{ position: 'relative', display: 'inline-flex' }}>
      <CircularProgress
        variant="determinate"
        sx={(theme) => ({
          color: 'var(--tint)',
          ...theme.applyStyles('dark', {
            color: 'var(--tint)',
          }),
        })}
        {...props}
        value={100}
      />
      <CircularProgress
        variant="determinate"
        disableShrink
        sx={(theme) => ({
          color: 'var(--accent)',
          animationDuration: '550ms',
          position: 'absolute',
          left: 0,
          [`& .${circularProgressClasses.circle}`]: {
            strokeLinecap: 'round',
          },
          ...theme.applyStyles('dark', {
            color: 'var(--accent)',
          }),
        })}
        {...props}
      />
      <Box className="inset-0 absolute flex items-center justify-center">
        <Typography
          variant="caption"
          component="div"
          sx={{ color: 'text.secondary', fontSize: (Number(size) || 40) / 3 }}
        >{`${Math.round(value)}%`}</Typography>
      </Box>
    </Box>
  );
};
